import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { useBranding, useSiteFlags } from "./BrandedSection";
import { LinkIcon } from "./linkIcons";
import { externalLinksOrDefault, isAdultLink } from "../lib/externalLinks";

export default function ExternalLinks({ ready = false }) {
  const { links = [] } = useBranding();
  const { live_status_enabled: liveEnabled } = useSiteFlags();
  const [live, setLive] = useState({ twitch: false, kick: false });
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(false);
  const effectiveLinks = externalLinksOrDefault(links);
  const enabledLinks = effectiveLinks.filter((link) => link.enabled !== false).sort((a, b) => (a.order || 0) - (b.order || 0));

  useEffect(() => {
    const hasLiveNetwork = effectiveLinks.some((link) => link.enabled !== false && (link.network === "twitch" || link.network === "kick"));
    if (!liveEnabled || !hasLiveNetwork) return undefined;
    let active = true;
    setLoading(true);
    api.get("/live-status")
      .then((response) => { if (active) setLive({ twitch: !!response.data.twitch, kick: !!response.data.kick }); })
      .catch(() => { if (active) setErr(true); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [liveEnabled, effectiveLinks]);

  if (!enabledLinks.length) return null;
  return (
    <div className="xs-external-links" data-testid="external-links">
      <div className="xs-link-tree">
        {enabledLinks.map((link, index) => {
          const isLive = liveEnabled && ((link.network === "twitch" && live.twitch) || (link.network === "kick" && live.kick));
          const adultLink = isAdultLink(link.url);
          const gateUrl = `/age-gate?url=${encodeURIComponent(link.url)}`;
          return (
            <a
              key={link.id || `${link.network}-${link.url}`}
              href={adultLink ? gateUrl : link.url}
              target={adultLink || link.network === "email" ? undefined : "_blank"}
              rel={adultLink || link.network === "email" ? undefined : "noreferrer"}
              className={`xs-link xs-link-tree-item xs-stagger ${ready ? "show" : ""} ${isLive ? "xs-link-live" : ""}`}
              data-testid={`ext-link-${link.id || link.network}`}
              aria-label={isLive ? `${link.label} (streaming live now)` : link.label}
              style={{ transitionDelay: ready ? `${index * 80}ms` : "0ms" }}
              data-state={ready ? "show" : "hidden"}
            >
              <LinkIcon network={link.network} size={30} />
              <span>{link.label}</span>
              {isLive && <span className="xs-live-badge"><span className="xs-live-dot" /> LIVE</span>}
            </a>
          );
        })}
      </div>
      {liveEnabled && enabledLinks.some((link) => ["twitch", "kick"].includes(link.network)) && (
        <div className="xs-live-refresh-row" data-testid="live-refresh-row">
          <span data-testid="live-status-label">{loading ? "checking live status..." : err ? "live status unavailable" : live.twitch || live.kick ? "streaming right now" : "offline"}</span>
        </div>
      )}
    </div>
  );
}
